module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "paraz"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "chapter03"
    }
  }), _vm._v("Most of the clients at the Center for Anxiety Disorders share a certain look, a presence at once extinguished and buzzing. Their breathing is heavy, effortful and disorganized. Their eyes scan random magazines, retaining nothing. Their hands clasp the arms of their chairs as if a countdown has just begun at the end of which they will be launched into space in a terrifying heave. The psychologist is used to the haunted looks in the waiting room at all hours, the squashing of tissue paper, the wriggling fingers, and the terrified yawns. Still, when he entered the waiting room a week ago, exactly at four o’clock, he was taken aback by the sight of her. She was pale and slight like a refugee. Urban war paint was splashed over her face—black mascara, red lipstick. She stood up to greet him, fumbled forward on tall, clear heels. She did not look into his eyes but hung her gaze around his neck like a childish hug. He introduced himself and led her to the therapy room. She sat down "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("on the sofa, dug noisily in her handbag, took out a cigarette and fumbled with it. A sharp scent of perfume hung over her. He sat in front of her and leafed through the forms; her handwriting, scribbled and hesitant, signaled sadness and neglect.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("What brings you here today? That’s how he always begins his intake sessions. Fans of the cranky Viennese hold that you should sit quietly and let the client lead. But in this, he thinks, they are mistaken, or at least overzealous, as in a host of other concerns. In the night class he teaches, Introduction to the Principles of Therapy, he quarrels with them, and perhaps also with the therapeutic enterprise as a whole.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She took her time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Somebody spiked my drink.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Someone put a drug in your drink?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She nodded: I sat down for a drink with a friend at the club. Then I got up to dance. Suddenly my head began spinning. I felt nauseous. I didn’t know where I was. I started sweating. I felt I was going crazy. I couldn’t breathe. I thought I was dying. I ran outside. One of the girls, a friend of mine, took me home. Since then I can’t dance there anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("So what? he asked and immediately chided himself; too early to confront the client like this. It is useful and customary to wait, establish rapport. But his patience has been waning recently, and at any rate, those who suffer from anxiety convince themselves that some disaster is approaching. This very conviction is of course their real disaster, which tortures them and destroys their lives.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She squinted: So what?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He nodded: Your drink was spiked and you can’t go dancing in the club. So what?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I have to dance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("You like to dance at clubs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I need to dance. For money. I’m a dancer at a nightclub.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A stripper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A dancer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("He looked at her again. Dark raven eyes wide open; freckled upturned nose. Old acne scars dot her pale face. She looked at him. Here is a crucial moment, he thought. She is checking to see if I will judge or patronize her. He knew he would pass this test. He doesn’t judge his clients, doesn’t compete with them, and doesn’t carry their load. This position is fundamental to his therapeutic approach. He is very proud of it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Eager therapists, the people-persons who drip with goodwill and sympathy, theirs is a false promise, and theirs is a wounding touch, he will say later in class. A therapist who rushes to help forgets to listen, and therefore cannot understand, and therefore cannot see. The eager therapist, the one who’s determined to offer salvation, involves himself and seeks his own salvation. The good psychologist keeps his distance and does not involve himself in the results of his work. The right distance allows a deep and clear gaze. The good psychologist reserves the business of closeness for family members and beloved pets and leaves the business of salvation to religious officials and street corner eccentrics.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Such absence of involvement is not an intuitive position, he will tell his students, and is not easy to maintain. Even the cranky Viennese, who thought and spoke of it so much, failed the test of conduct, which is the ultimate test, because his curiosity and conquistador’s temperament overwhelmed him. But the therapeutic enterprise itself runs counter to our basic intuitions and cannot be understood without acknowledging the value of estrangement. Why would someone spill his intimate secrets to a total stranger if there is not something healing about estrangement? Now you may say, people seek in psychologists their knowledge, not their estrangement. But those among you who are cursed with a family member who’s a psychologist will attest to the futility of approaching them with your problems. A therapeutic encounter will not happen. Relief will not be found. Your relatives and friends are invested in your life. Their involvement with you is in part self-involvement, "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("and so their view of you is distorted, which creates confusion and chafing—sparks aplenty, but neither light nor enlightenment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The good psychologist is not infatuated with humanity, he will add later. Please, all you humanitarians rushing to the bedside, the bleeding hearts and altruists, the fragile egos among you who covet a deep tan under the light of another’s gratitude, the merchants of secrets, please move over—here he will wave his hands in a dramatic gesture. (Pedagogy is theater, he likes to tell Nina, and not only in the sense that it is a deception.) The good psychologist, he’ll continue, is ambivalent about people, because he knows well their treacherous nature, their potential for destruction, delusion, and deceit. The good psychologist aims to be fully present and to move correctly about the inner space. His infatuations he’d better keep to himself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("A dancer. You are here today so I can help you get back on stage?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Yes. I try to go to the club most nights. I hang around the bar. I help with this and that. But I can’t dance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("And this is the first time you’ve experienced something like this?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Something like what?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A feeling of terror and fear—nausea and disorientation that appear out of the blue, all at once.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She scratched her face and her eyes darted around the room, random and fearful like a trapped bird. Yes. No . . . umm, yes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Who do you think spiked your drink?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Do you know who runs the strip clubs in this town?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("No.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Russian mob.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Russian mob spiked your drink?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She fell silent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Is there someone specific who’d want to hurt you?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("Suddenly she was crying. Her eyes became red. Her shoulders shook. He waited. Finally he leaned over and handed her a tissue. He marked this moment to himself. Crying is the trail of blood that leads to the corpse in the bushes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It’s possible that we’re not talking about a drug at all, he said. The experience of a panic attack is very disorienting and sudden, with no clear cause. There is a natural inclination to seek an external explanation for these feelings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("You think I’m crazy?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I don’t know what that is.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("You’re a psychologist and you don’t know what crazy is?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Crazy")]), _vm._v(" means insane. "), _c('em', [_vm._v("Insanity")]), _vm._v(" is a legal term. We don’t use it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I’m not crazy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("We are not in court.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He checked to see if she was offended by his bluntness, but she continued: I’m the featured dancer. I started a year ago and I’m already the featured dancer. My boss says that I’m the best. I make hundreds of dollars a night. But I sleep late. We’ll have to meet in the afternoon.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I usually close at three.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Four is the earliest I can do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He nodded. We could, then, meet at four.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("You’ll stay late for me? Her voice trembled at the edge.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I’m flexible. We’re dealing with people here. Four is still reasonable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Thanks, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The treatment protocol I use is demanding and intensive. You’ll need to practice, read, and work at home. We don’t lie on the couch and discuss bedwetting and dreams.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I know how to work. I’m ready.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("OK.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Why did this happen to me, the panic?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Everything meaningful that happens has many reasons, never one. But that is less important now.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Less important?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("You don’t need to know what caused a flat tire. You just need to find the hole and patch it. You can chase a burglar out of your home even without figuring out how and why he broke in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She looked at him, her brow furrowed with suspicion. She nodded slowly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("They got up and he opened the door. On her way out she turned and stood in front of him. Too close, he thought. Her breasts bulged under her blouse.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("You can really help me?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("No, he said, but I can support you in a process where you’ll learn to help yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He stretched out his hand. She shook it. Her palm was dry and soft.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Next Friday, four o’clock, he said, and she left.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He sat down at his desk and called Nina.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Dr. Michaels, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Dr. Michaels, he replied in a softly mocking tone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ah, it’s you. Her voice brightened.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Dr. Michaels, I need help.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Pray, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("To whom? God? Well, yes, as a matter of fact I had a thing with her, years ago. We were both drunk. Or at least I was. Anyway, we spent a night together. The next morning she vanished and never called back. Didn’t even leave a number, and I’ve never seen her since. In truth, I still harbor some resentment, but I learned to forgive, to let go . . .")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I can’t believe they gave you a clinical license, she laughed. If your clients knew who they were involved with . . .")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Who are they involved with?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Someone who hears the word "), _c('em', [_vm._v("God")]), _vm._v(" and relates it to sex. It’s worrisome.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I also link you to sex. Isn’t that worrisome?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("We were not drunk, and I didn’t disappear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("You disappeared.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I didn’t disappear. I left.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("Objectively speaking, yes, but at the level of subjective experience . . .")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She fell silent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I was in love. His voice cracked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A short silence. Her voice softened: I will always be yours in a certain sense. You know that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In a certain sense. Yes. Yes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A long pause.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("Her voice softened further: Hey, you, it’s good to hear your voice. How are you doing?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("OK. Busy day. A busy week.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("You’re taking on too much. A hypomanic episode?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Sure. You see right through me. You have a future in this business.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("At least one of us has, then.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I have a new case here, a stripper with stage fright.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("You’re kidding.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I’m serious. Twenty-five-years old, a bit borderlinish, not entirely, neurotic without psychosis, cries easily, doe-eyed, but not empty; stands too close, anxious. Childhood trauma, if I had to guess.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Drugs?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Denies in the forms, but likely. I’ll return to that later.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("IQ?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Normal, it appears. Graduated high school, not that it means anything; argumentative but unpolished.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Appearance?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Outwardly directed. Not disheveled. Heavy makeup. Heels, don’t ask.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Eye contact?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Comes and goes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Attractive? Flirtatious?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Childish. Cautious.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Relationship?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("Single. Beyond that I’ll have to find out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("You are going to need my help.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I am going to need your help.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("How will you pay me for my services?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("You will receive respect. You will do some good in the world. That kind of stuff matters to you, if I recall correctly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Yes. Yes, but actual compensation is also needed. I’ll think about it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Whatever you want.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I’m running to get Billie from day care. We’ll talk later.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("You should have married me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("You’re incessant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("We were discussing you. Don’t change the subject.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I have to run. I e-mailed you a picture of Billie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Gorgeous child; resembles her mother.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Go home, you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Home, yes. Bye.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("They had met five years ago in the hospital where he used to work until he tired of the endless dead-end meetings and corridors and opened his own small office with the big name in the heart of the city. She had come for a postdoc with the hospital’s Anxiety Service. One day he knocked on her door to see if he could borrow a book. She was in the middle of a phone call and motioned him in with her hand. As he was digging in the shelves, he heard her laughing and snorting; he looked up and saw her leaning back in her chair, legs crossed, a large head on a long, thin neck, short, black hair, lush lips, asymmetrical smile. Her feet, tanned, generous, attracted his attention for some reason. On her right ankle he noticed a tattoo of a small rose. In time he would caress and bite her there and she’d say, are you here to smell it or pick it?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Are you new?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Do I look new? Her eyes—curious, mischievous.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He examined her with a theatrical furrow of his brow. Used. "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("Good condition, he said without thinking, because something in the air around her sang, and her tilted head exposed her neck, a tract of smooth, supple skin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She laughed. If you buy me lunch, maybe I’ll forget to get offended.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Lunch is on me, then.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Several weeks later, during lunch at the cafeteria in the basement, he said, we have something going on between us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I’m married.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("So what?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She laughed: I love my husband.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Of course, otherwise why get married? Tell me about him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He’s a carpenter by trade. But currently out of commission. He’s sick. Some autoimmune curse no one can really treat or pronounce. It’s complicated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Your husband is handicapped. What chances do I have against a handicapped man?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("You have no chance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Several days later, in a crowded café at the center of town he asked, what’s your most sensitive spot?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Behind the knees. That’s the secret location.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He reached under the table and touched her there. Her face reddened.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Continue, she said. You’re clear that we’re not going to bed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I’m not religious about this, he said. We could go to the park, to the lawn . . .")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She smiled, continue.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("If I were brave, or romantically inclined, I would kiss you right now.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Continue, she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He did. And so did she. They went on together. They rose like a river during rainy season. And when he looked in her eyes he felt as if the big bang had reversed course and collapsed back and the whole universe, the total range of consciousness, all matter and electricity had gathered at once in that dark, dense core.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("Winter of that year, in a parked car on a darkened dirt road on the edge of town, they sat and listened to the calm outside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I want to ask a big favor of you, unfairly. It’s important to me that we both understand this.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Unfairness is one thing I get intuitively, he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I want to have a child. My husband and I have been trying for years, but with his illness and the treatments, it’s complicated. The odds are not good, and time . . .")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("You want to have a baby with me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I will never leave him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I know.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Not because he is ill. Because I love him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I know.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She turned and looked at him: Swear to me that you can contain this, that this is OK with you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I swear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I could never repay you. I will not try.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Nothing to repay; you in the world and happy, even if not with me, that’s payment enough.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("We’ve known each other for only a year, maybe less, and yet I feel as if you always were . . . I trust you. And it’s not based on data, but on a gut feeling. And we both know that gut feelings should not be trusted, and yet . . .")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I will not betray your trust.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("You think we’re crazy?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("We are psychologists.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Well, that explains a lot.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Not everything needs to be explained.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("After that she gathered her knees to her chest, took off her panties in one swift motion, turned and climbed astride him. She led him into her with a steady hand. Her head hit the roof of the car and she laughed. She unbuttoned her blouse and leaned into him. The warmth of her skin calmed him. He hugged her. He closed his eyes and felt her on him, warm and decisive. He gathered her toward him and came in silence. "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("They remained like this, hugging, for a long while. She took his head in her hands. She looked at him and kissed his forehead. She said, I love you. Two weeks later she collected her belongings and her books and her fingers that played magic on his skin and her husband with his cane and left. Nine months later a letter arrived, and a picture; after that an e-mail. And shortly after that the phone calls began.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-181c301d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter03.vue
// module id = 87
// module chunks = 0